/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { offBoardingService } from '../../../../api/services/offBoardingService';
import { setLoading } from '../../../../infra/aggregates/LoaderSlice';
import { setOffBoardingList } from '../../../../infra/aggregates/myProfile/offBoardingAggregates/offBoardingListSlice';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import DTOOffBoardingForm from './DTOOffBoardingForm';
import OffBoardingFormPresenter from './OffBoardingFormPresenter';
import { useTranslation } from 'react-i18next';

function OffBoardingFormController() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state);
  const [reasons, setReasons] = useState([]);
  const [letterTypes, setLetterTypes] = useState([]);
  const [hireDate, setHireDate] = useState('');

  function getFormData(data: any) {
    addOffBoardingData(data);
  }

  function getReasons(data: any) {
    setReasons(data);
  }

  function getHireDate(data: any) {
    setHireDate(data);
  }
  function getLetterTypes(data: any) {
    setLetterTypes(data);
  }

  const addOffBoardingData = (data: any) => {
    const compId: any = selector.authSlice.company_id;
    const empId: any = selector.authSlice.emp_id;

    const formData = new FormData();
    formData.append('waive_notice_period', data?.waive_notice_period);
    formData.append('revive_letter', data?.revive_letter);
    formData.append('resignation_reason', data?.resignation_reason);
    formData.append('registration_date', data?.registration_date);
    formData.append('notice_period', data?.notice_period);
    formData.append('notice_date', data?.notice_date);
    formData.append('experience_letter', data?.experience_letter);
    if (data?.newattachement) {
      formData.append('attachment', data?.attachment);
    }

    formData.append('remarks', data?.remarks);
    formData.append('company_id', compId);
    formData.append('emp_id', empId);
    dispatch(setLoading(true));
    offBoardingService
      .addEmpBoarding(formData)
      .then((response: any) => {
        if (response?.response == 'success') {
          window.location.reload();
          // dispatch(setOffBoardingList(response?.data));

          toast.success(t('Added Successfully'));

          dispatch(setLoading(false));
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        toast.error(err?.response?.data?.data);
      });
  };
  return (
    <>
      <DTOOffBoardingForm
        setHireDateData={getHireDate}
        setReasonsForResignations={getReasons}
        setLettersType={getLetterTypes}
      />
      <OffBoardingFormPresenter
        setFormData={getFormData}
        reasons={reasons}
        letterTypes={letterTypes}
        hire_date={hireDate}
      />
    </>
  );
}

export default OffBoardingFormController;
